import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";

import Navigation from "./navigation";
import Overview from "./overview";
import InstallURL from "./installurl";
import Theme from "./theme";
import Publish from "./publish";

import { fetchTemplatesWizardStep, fetchSiteDetails } from "../../actions";

class TemplatesWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.fetchTemplatesWizardStep("step_1");
    this.props.fetchSiteDetails(this.props.session);
  }

  proceedtoNextStep() {
    // this.setState({sessionShowenable:false});
    // this.props.fetchWizardStep('step_5');
  }

  render() {
    let { TemplatesWizardStep, deviceSize } = this.props;
   

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        {/* <div style={{ width: "100%", marginBottom: 10 }}> */}
        <Navigation />

        {TemplatesWizardStep == "step_1" ? (
          // <div className="row" style={{ margin: 0 }}>
          <Overview />
        ) : // </div>
        TemplatesWizardStep == "step_2" ? (
          // <div className="row" style={{ margin: 0 }}>
          <InstallURL />
        ) : // </div>
        TemplatesWizardStep == "step_3" ? (
          // <div className="row" style={{ margin: 0 }}>
          <Theme />
        ) : // </div>
        TemplatesWizardStep == "step_4" ? (
          // <div className="row" style={{ margin: 0 }}>
          <Publish history={this.props.history} />
        ) : (
          // </div>
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    TemplatesWizardStep: state.TemplatesWizardStep,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  fetchTemplatesWizardStep,
  fetchSiteDetails,
})(TemplatesWizard);
